import React from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Card } from 'antd';
import { bindActionCreators } from 'redux';
import { Text } from '../../shared/components';
import PacientesFiltrableTable from './buscadorPacientes.grideable';
import Page from '../../shared/components/layout/Page.layout';
import {
  establecerCliente,
} from '../../../state/actions/creators/encargos.creador.actioncreator';

//TODO: A eliminar
class BuscadorPacientes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowKeys: [],
    };
  }

  render() {
    const { selectedRowKeys } = this.state;
    const { tiendas, onSeleccionarPaciente } = this.props;
    return (
      <Card>
        <PacientesFiltrableTable
          className="hide-selection-radius cursor-default"
          endpoint="CREAR_ENCARGO_BUSCAR_PACIENTE_MODAL"
          size="middle"
          onRow={record => ({
            onClick: () => { this.setState({ selectedRowKeys: [record.id], record }); },
            onDoubleClick: () => {
              onSeleccionarPaciente(this.state);
            },
          })}
          rowSelection={{
            type: 'radio',
            selectedRowKeys,
            onChange: e => this.setState({ selectedRowKeys: e }),
          }}
          onSearch={() => {
            this.setState({ selectedRowKeys: [] });
          }}
          columns={[
            {
              title: 'ID',
              dataIndex: 'id',
              align: 'right',
            },
            {
              title: 'Nombre',
              dataIndex: 'nombre_completo',
              render: (text, record) => {
                const { nombre_1, nombre_2 } = record;
                return `${nombre_1 || ''} ${nombre_2 || ''}`;
              },
            },
            {
              title: 'Apellidos',
              dataIndex: 'apellido_1',
              render: (text, record) => {
                const { apellido_1, apellido_2 } = record;
                return `${apellido_1 || ''} ${apellido_2 || ''}`;
              },
            },
            {
              title: 'Teléfono',
              dataIndex: 'telefono_1',
            },
            {
              title: 'Graduación',
              dataIndex: 'fecha_ultima_gradopt',
              render: (text, record) => {
                const { fecha_ultima_gradopt, fecha_ultima_gradcontac } = record;
                if (fecha_ultima_gradopt && fecha_ultima_gradcontac) return 'Opt. y Con.';
                if (fecha_ultima_gradopt) return 'Optométrica';
                if (fecha_ultima_gradcontac) return 'Contactologica';
                return '';
              },
            },
            {
              title: 'Tienda',
              dataIndex: 'tienda_id',
              maxWidth: 300,
              render: (text, record) => {
                const { tienda_id } = record;
                if (tiendas) {
                  const tienda = tiendas.find(tienda => tienda.id === tienda_id);
                  if (tienda) return tienda.nombre;
                }
                return '';
              },
            },
          ]}
        />
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  const { core: { tiendas } } = state;
  return {
    tiendas,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    establecerCliente,
  }, dispatch);
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BuscadorPacientes);

BuscadorPacientes.propTypes = {
  tiendas: PropTypes.any,
};

BuscadorPacientes.defaultProps = {
  tiendas: [],
};
